import { InvalidArgumentError } from '@commander-js/extra-typings';
import { z } from 'zod';

const DOMAIN_REGEX =
  /^(?=.{4,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

export function validateDomain(value: string) {
  const parsed = z
    .string()
    .regex(DOMAIN_REGEX)
    .safeParse(value.trim().toLowerCase());

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError(
    'Value must be a valid domain including a TLD, for example "example.com"'
  );
}

const querySchema = z.string().trim().min(3).max(100);

export function validateQuery(value: string) {
  const parsed = querySchema.safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Query must be between 3 and 100 characters');
}

const limitSchema = z.coerce.number().int().min(1).max(20);

export function validateLimit(value: string) {
  const parsed = limitSchema.safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be an integer between 1 and 20');
}

const MAX_TLDS = 10;

export function collectTld(value: string, previous: string[] = []): string[] {
  const tld = value.trim().toLowerCase().replace(/^\./, '');
  const tlds = tld.length > 0 ? [...previous, tld] : previous;

  if (tlds.length > MAX_TLDS) {
    throw new InvalidArgumentError(`You can pass at most ${MAX_TLDS} TLDs`);
  }

  return tlds;
}
